<template>
    <div class="container">
        <ul v-if="maps && maps.length > 0">
            <li v-for="map of maps" v-bind:key="map.id">
                <router-link :to="mapUrl(map)">
                    <img class="mapBanner" :src="mapBannerUrl(map)" />
                    {{ mapName(map) }}
                </router-link>
            </li>
        </ul>

        <div v-if="!maps || maps.length == 0" class="empty-list">{{ $t("admin.maps.no_maps_available") }}</div>
    </div>
</template>

<script>
import Publisher from "@/model/Publisher.js"
import MapService from "@/service/MapService.js"
import LangUtils from "@/utils/LangUtils.js"

const mapService = new MapService();

export default {
    props: {
        publisher: Publisher
    },

    data() {
        return {
            maps: null
        }
    },
    
    watch: {
        publisher: function(newValue, oldValue) {
            if (newValue != oldValue) {
                this.loadMaps();
            }
        }
    },

    methods: {
        loadMaps() {
            if (this.publisher != null) {
                mapService.loadMapsForPublisher(this.publisher.id).then((maps) => {
                    this.maps = maps;
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        mapName(map) {
            return LangUtils.valueForLanguage(map.getName(), this.$i18n.locale);
        },

        mapUrl(map) {
            return "/admin/map/" + map.getId();
        },

        mapBannerUrl(map) {
            return map != null ? "https://images.weserv.nl/?url=" + LangUtils.valueForLanguage(map.getMapBannerUrl(), this.$i18n.locale) : "";
        },
    },

    mounted() {
        this.loadMaps();
    }
}
</script>

<style scoped>
.container {
    padding: 0px;
    text-align: left;
}

ul {
    display: grid;
    grid-template-columns: 50% 50%;
    column-gap: 8px;
    list-style: none;
    padding: 0px;
    width: 100%;
    height: 100%;
    overflow: scroll;
}

li {
    margin-top: 8px;
}

li img {
    display: block;
    height: 100px;
}

.empty-list {
    color: #777777;
    font-size: 18px;
    font-weight: bold;
    margin-top: 64px;
    text-align: center;
}

</style>